import { RESET_STATE } from 'store/global/actions';

import { PREPARE_DISCLOSURES_WIZARD_ACTION_TYPE } from '../actions/prepareDisclosuresWizard.actions';

const initialState = {
  isOpen: false,
};

const prepareDisclosuresWizard = (state = initialState, { type }) => {
  switch (type) {
    case PREPARE_DISCLOSURES_WIZARD_ACTION_TYPE.OPEN:
      return { ...state, isOpen: true };

    case PREPARE_DISCLOSURES_WIZARD_ACTION_TYPE.CLOSE:
      return { ...state, isOpen: false };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default prepareDisclosuresWizard;
